import React, {useState} from "react";
import {Question} from "../../../../../mobx/stores/questions/models";
import {Collapse, Divider, Grid, IconButton, Link, Paper, Typography} from "@mui/material";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {QuestionRenderDescription} from "../QuestionRenderDescription";
import {QuestionRenderProblem} from "../QuestionRenderProblem";
import {QuestionRenderHint} from "../QuestionRenderHint";
import {QuestionRenderSolution} from "../QuestionRenderSolution";
import {QuestionRenderAnswer} from "../QuestionRenderAnswer";
import {useHistory} from "react-router-dom";
import {DefaultRoutes} from "../../../../../routes";
import {observer} from "mobx-react-lite";
import {useMst} from "../../../../../mobx";
import {GridStyled} from "./QuestionRender.styles";
import {FeatureAppearance} from "../../../../FeatureAppearance";

interface QuestionRenderProps {
	question: Question;
	loading: boolean;
}

export default observer(function QuestionRender({ question, loading }: QuestionRenderProps) {
	const { skillsStore, topicsStore } = useMst();
	const { getSkillsData } = skillsStore;
	const { getTopicsData } = topicsStore;
	const [expanded, setExpanded] = useState(true);
	const { push } = useHistory();

	const onHandleExpand = () => setExpanded((prevState) => !prevState);
	const onHandleQuestionEdit = () => push(`/${DefaultRoutes.questions}/edit/${question.id}`);

	return (
		<Grid item xs={12} sx={(theme) => ({ margin: theme.spacing(2, 0) })}>
			<Paper elevation={4} sx={() => ({ minWidth: "320px", overflow: "auto" })}>
				<Grid
					onClick={onHandleExpand}
					container
					alignItems={"center"}
					wrap={"nowrap"}
					justifyContent={"space-between"}
					sx={(theme) => ({ cursor: "pointer", padding: theme.spacing(2) })}
				>
					<Grid container alignItems={"center"} item>
						<Typography variant={"h6"}>{question.title}</Typography>
						<FeatureAppearance feature={["questions.questions.any.create", "questions.questions.any.update"]}>
							{(featureExist) => {
								return featureExist
									? (
										<Link
											underline={"hover"}
											onClick={onHandleQuestionEdit}
											sx={(theme) => ({ cursor: "pointer", marginLeft: theme.spacing(2) })}
										>
											Редактировать
										</Link>
									) : null;
							}}
						</FeatureAppearance>
					</Grid>
					<IconButton>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
				</Grid>
				<Divider />
				<Collapse in={loading || expanded} timeout={"auto"}>
					<GridStyled container direction={"column"} sx={(theme) => ({ padding: theme.spacing(2) })}>
						<QuestionRenderDescription
							difficulty={question.difficulty}
							type={question.class}
							skills={getSkillsData.filter((skill) => question.skills.find((x) => x.id === skill.id))}
							topics={getTopicsData.filter((topic) => question.topics.find((x) => x.id === topic.id))}
						/>
						<Divider variant={"fullWidth"} sx={(theme) => ({ margin: theme.spacing(1, 0) })} />
						<QuestionRenderProblem problem={question.problem} />
						{question.hint ? <Divider variant={"fullWidth"} sx={(theme) => ({ margin: theme.spacing(1, 0) })} /> : null}
						<QuestionRenderHint hint={question.hint} />
						{question.solution ? (
							<Divider variant={"fullWidth"} sx={(theme) => ({ margin: theme.spacing(1, 0) })} />
						) : null}
						<QuestionRenderSolution solution={question.solution} />
						{question.correct_answer ? (
							<Divider variant={"fullWidth"} sx={(theme) => ({ margin: theme.spacing(1, 0) })} />
						) : null}
						<QuestionRenderAnswer answer={question.correct_answer} />
					</GridStyled>
				</Collapse>
			</Paper>
		</Grid>
	);
});
